// src/pages/FaqPage.jsx
import React from 'react';
// Constants
import { KeywordsPages, CompanyName } from '../../utils/Constants';
// Data
import {
  faqPageAdditionalMeta,
  faqPageStructuredData,
} from '../../utils/data/MetaData';
// Components
import Navbar from '../../components/nav/Navbar';
import { HelmetItem } from '../../components/utils/HelmetItem';
import FaqPageMainContainer from '../../components/faq/FaqPageMainContainer';
import FooterComponent from '../../components/footer/FooterComponent';

function FaqPage() {
  return (
    <>
      {/* Tab Data */}
      <HelmetItem
        PageName='FAQ'
        desc={`Answers about ${CompanyName} bookings, screening, etiquette, online vs. in-person sessions, and what to expect.`}
        keywords={KeywordsPages}
        additionalMeta={faqPageAdditionalMeta}
        structuredData={faqPageStructuredData}
      />

      {/* Page */}
      <div className='grid min-h-screen overflow-hidden bg-colour2 text-colour1 font-poppins'>
        <div className='grid'>
          {/* Navigation */}
          <Navbar />

          {/* Header */}
          <header className='grid gap-4 place-items-center border-b-4 border-colour6 px-6 py-10 text-center'>
            <h1 className='neon_text_heavy_redpink font-titleFont text-4xl tracking-wider drop-shadow-lg md:text-6xl'>
              FREQUENTLY ASKED QUESTIONS
            </h1>
            <p className='max-w-[65ch] text-base leading-relaxed md:text-lg'>
              Read this before you message Me. It keeps things efficient,
              precise, and worthy of My time.
            </p>
          </header>
        </div>

        {/* Main page content */}
        <FaqPageMainContainer />

        {/* Footer */}
        <FooterComponent />
      </div>
    </>
  );
}

export default FaqPage;
